import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'cert-month-year-picker',
  templateUrl: './month-year-picker.component.html',
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  styles: ``,
  standalone: false,
})
export class MonthYearPickerComponent {
  @Input()
  propertyName = '';

  @Input()
  model!: string;

  @Input()
  name!: string;

  @Input()
  minDate!: string;

  @Input()
  maxDate!: string;

  @Input()
  defaultDate!: string;

  @Input()
  isDisabled = false;

  @Input()
  isRequired = false;

  isFieldValid = true;

  modelString = '';

  @Output() modelChange = new EventEmitter<string>();

  errorEmitter = new EventEmitter<any>();

  flatPicker!: any;

  updateModel(date: string) {
    this.model = date;

    this.modelChange.emit(this.model);
  }

  onKeyDown(key: any) {
    if (key.which !== 8) {
      const numChars = key.target.value.length;
      if (numChars === 2) {
        let thisVal = key.target.value;
        thisVal += '/';
        key.target.value = thisVal;
      }
    }
  }
}
